import { makeColorSetClass } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { TruncatedText } from './components';
import { Metadata } from './Metadata';
const OverlayWrapper = styled.div `
  display: block;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;
  padding: 12px;
  padding-top: 32px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 32.29%,
    rgba(0, 0, 0, 0.5) 100%
  );
`;
const BlurbAndMetadata = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 12px;
`;
export const Overlay = styled.div `
  display: flex;
  flex-direction: row;
`;
export const VideoOverlay = ({ blurb, metadata, className, }) => {
    return (React.createElement(OverlayWrapper, { className: `${makeColorSetClass('invertedDark')} ${className}`, tabIndex: -1 },
        React.createElement(Overlay, null,
            React.createElement(BlurbAndMetadata, null,
                blurb && (React.createElement("div", { style: {
                        paddingInlineEnd: (metadata === null || metadata === void 0 ? void 0 : metadata.artistImage) !== undefined ? '44px' : 'unset',
                    } },
                    React.createElement(TruncatedText, { lines: 4, semanticColor: "textBase", variant: "finaleBold" }, blurb))),
                React.createElement(Metadata, { ...metadata })))));
};
